// ! AUTO-GENERATED FILE
// ! DO NOT TOUCH !!!

// #pause-sonar#
import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import {
  createRecourseCriteria,
  CreateRecourseCriteria$Params,
} from '../fn/recourse-criteria/create-recourse-criteria';
import {
  findAllRecourseCriteria,
  FindAllRecourseCriteria$Params,
} from '../fn/recourse-criteria/find-all-recourse-criteria';
import {
  findRecourseCriteriaById,
  FindRecourseCriteriaById$Params,
} from '../fn/recourse-criteria/find-recourse-criteria-by-id';
import {
  updateRecourseCriteria,
  UpdateRecourseCriteria$Params,
} from '../fn/recourse-criteria/update-recourse-criteria';
import { CreateRecourseCriteriaRestResponse } from '../models/create-recourse-criteria-rest-response';
import { RetrieveRecourseCriteriaRestResponse } from '../models/retrieve-recourse-criteria-rest-response';
import { UpdateRecourseCriteriaRestResponse } from '../models/update-recourse-criteria-rest-response';
import { StrictHttpResponse } from '../strict-http-response';

@Injectable({ providedIn: 'root' })
export class RecourseCriteriaService extends BaseService {
  /** Path part for operation `findRecourseCriteriaById()` */
  static readonly FindRecourseCriteriaByIdPath = '/recourse-criteria/{id}';

  /**
   * Get recourse criteria by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findRecourseCriteriaById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findRecourseCriteriaById$Response(
    params: FindRecourseCriteriaById$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<RetrieveRecourseCriteriaRestResponse>> {
    return findRecourseCriteriaById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get recourse criteria by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findRecourseCriteriaById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findRecourseCriteriaById(
    params: FindRecourseCriteriaById$Params,
    context?: HttpContext,
  ): Observable<RetrieveRecourseCriteriaRestResponse> {
    return this.findRecourseCriteriaById$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<RetrieveRecourseCriteriaRestResponse>): RetrieveRecourseCriteriaRestResponse => r.body,
      ),
    );
  }

  /** Path part for operation `updateRecourseCriteria()` */
  static readonly UpdateRecourseCriteriaPath = '/recourse-criteria/{id}';

  /**
   * Update existing recourse criteria.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateRecourseCriteria()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRecourseCriteria$Response(
    params: UpdateRecourseCriteria$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<UpdateRecourseCriteriaRestResponse>> {
    return updateRecourseCriteria(this.http, this.rootUrl, params, context);
  }

  /**
   * Update existing recourse criteria.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateRecourseCriteria$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRecourseCriteria(
    params: UpdateRecourseCriteria$Params,
    context?: HttpContext,
  ): Observable<UpdateRecourseCriteriaRestResponse> {
    return this.updateRecourseCriteria$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateRecourseCriteriaRestResponse>): UpdateRecourseCriteriaRestResponse => r.body),
    );
  }

  /** Path part for operation `findAllRecourseCriteria()` */
  static readonly FindAllRecourseCriteriaPath = '/recourse-criteria';

  /**
   * Get all recourse criteria.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAllRecourseCriteria()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAllRecourseCriteria$Response(
    params?: FindAllRecourseCriteria$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<Array<RetrieveRecourseCriteriaRestResponse>>> {
    return findAllRecourseCriteria(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all recourse criteria.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findAllRecourseCriteria$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAllRecourseCriteria(
    params?: FindAllRecourseCriteria$Params,
    context?: HttpContext,
  ): Observable<Array<RetrieveRecourseCriteriaRestResponse>> {
    return this.findAllRecourseCriteria$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<Array<RetrieveRecourseCriteriaRestResponse>>,
        ): Array<RetrieveRecourseCriteriaRestResponse> => r.body,
      ),
    );
  }

  /** Path part for operation `createRecourseCriteria()` */
  static readonly CreateRecourseCriteriaPath = '/recourse-criteria';

  /**
   * Create new recourse criteria.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createRecourseCriteria()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createRecourseCriteria$Response(
    params: CreateRecourseCriteria$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<CreateRecourseCriteriaRestResponse>> {
    return createRecourseCriteria(this.http, this.rootUrl, params, context);
  }

  /**
   * Create new recourse criteria.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createRecourseCriteria$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createRecourseCriteria(
    params: CreateRecourseCriteria$Params,
    context?: HttpContext,
  ): Observable<CreateRecourseCriteriaRestResponse> {
    return this.createRecourseCriteria$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateRecourseCriteriaRestResponse>): CreateRecourseCriteriaRestResponse => r.body),
    );
  }
}

// #continue-sonar#
